import { ApolloClient } from '@apollo/client';
import { CurrentUserDocument, CurrentUserQuery } from './graphql.generated';

/**
 * Get the current user's roles from the Apollo client. This is a non hook base query, for scenarios like
 * tanstack router beforeLoad hooks.
 * @param apolloClient - The Apollo client to use
 * @returns The current user's roles
 */
export const getCurrentUserRoles = async (apolloClient: ApolloClient<unknown>) => {
	const currentUserQuery = await apolloClient.query<CurrentUserQuery>({
		query: CurrentUserDocument,
	});
	return currentUserQuery?.data?.currentUser?.roles ?? [];
};
